import React from "react";
import { Row, Col } from "react-bootstrap";
import CountUp from "react-countup";

const BannerPrincipal = () => {
  return (
    <Row id="bannerPrincipal">
      <Col md={{ span: 8, offset: 2 }} className="text-center">
        <h3
          data-aos="fade-down"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
          delay="100"
        >
          La tranquilidad de elegir la mejor piscina
        </h3>
        <p
          data-aos="zoom-in"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
          delay="500"
        >
          Sólo una piscina IPC Pools te ofrece la evolución constante
        </p>

        <div class="loading wave">9 Razones</div>
      </Col>
    </Row>
  );
};

export default BannerPrincipal;
